export default __webpack_public_path__ + "static/media/right_arrow.9641801f.svg";